import "./styles.css";
import { LibraryApp } from "./app";
import { renderAppStoreRelease } from "./app-store-release-page";
import { PRODUCT, TERMS_ROUTE, WEB_ROUTES } from "./config";
import { renderDesignReview } from "./design-review-page";
import { renderHowBuilt } from "./how-i-built-this";
import { renderMarkAttention } from "./mark-attention-page";
import { renderMarkPrompts } from "./mark-prompts-page";
import { renderMarketing } from "./marketing";
import { renderRoadmap } from "./roadmap-page";
import { renderPrivacy, renderSupport, renderTerms } from "./trust-pages";
import { renderUserActivities } from "./user-activities-page";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error(`${PRODUCT.name} web client root is missing`);

const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
if (pathname === WEB_ROUTES.marketing) {
  renderMarketing(root);
} else if (pathname === WEB_ROUTES.howBuilt) {
  renderHowBuilt(root);
} else if (pathname === WEB_ROUTES.markAttention) {
  await renderMarkAttention(root);
} else if (pathname === WEB_ROUTES.appStoreRelease) {
  renderAppStoreRelease(root);
} else if (pathname === WEB_ROUTES.userActivities) {
  renderUserActivities(root);
} else if (pathname === WEB_ROUTES.designReview) {
  await renderDesignReview(root);
} else if (pathname === WEB_ROUTES.markPrompts) {
  await renderMarkPrompts(root);
} else if (pathname === WEB_ROUTES.roadmap) {
  await renderRoadmap(root);
} else if (pathname === WEB_ROUTES.privacy) {
  renderPrivacy(root);
} else if (pathname === WEB_ROUTES.support) {
  renderSupport(root);
} else if (pathname === TERMS_ROUTE) {
  renderTerms(root);
} else {
  delete document.documentElement.dataset.surface;
  await new LibraryApp(root).start();
}
